import client from '../base-api';
import {downloadFile} from '@/shared/functions';

const serviceURL = '/user-contract';

const userContractService = {

    getMyContracts() {
        return client.get(`${serviceURL}/my`);
    },

    getDocument(documentId: number) {
        return client.get(`${serviceURL}/document/${documentId}`);
    },

    signDocument(documentId: number, signData: { position: number, digitalSignature: string }) {
        return client.post(`${serviceURL}/document/${documentId}/sign`, signData);
    },

    showDocumentPdf(documentId: number) {
        return downloadFile(`${serviceURL}/document/${documentId}/pdf`, `Vertrag_Dokument_${documentId}`);
    },

    // HR
    getUserContracts(userId: number) {
        return client.get(`${serviceURL}/user/${userId}`);
    },

    createContract(userId: number, contractType: string) {
        return client.post(`${serviceURL}/user/${userId}`, {contractType});
    },

    deleteContract(contractId: number) {
        return client.delete(`${serviceURL}/${contractId}`);
    },

    signDocumentBsg(documentId: number, signData: { position: number, digitalSignature: string }) {
        return client.post(`${serviceURL}/document/${documentId}/sign-bsg`, signData);
    },
}

export default userContractService;
